import React, { useState } from "react";
import ContractorSelect from "../ContractorSelect";
import LoadingButton from "../../dumb/LoadingButton";
import { assignTasksEditor } from "../../../redux/ducks/task";
import useModal from "../../../hook/useModal";
import useStatusThunk from "../../../hook/useStatusThunk";
import DisplayError from "../../dumb/DisplayError";

const AssignTaskEditor = props => {
    const [d_assignTasks, status, error, event] = useStatusThunk(assignTasksEditor);
    const [show, hide, renderModal] = useModal();

    const [assignTo, setAssignTo] = useState();

    event.onSuccess = () => {
        hide();
        setAssignTo(null);
    }

    const assign = () => {
        if (props.selectedTasks.length > 0) {
            d_assignTasks({ taskIDs: props.selectedTasks, userID: assignTo });
        }
    }

    return (
        <React.Fragment>
            <button className={"button button--safe " + props.className} onClick={show}>Editor</button>
            
            {renderModal(
                <div className="assign-task">
                    <div className="group">
                        <div className="label">Assign To</div>
                        <ContractorSelect onSelect={userID => { setAssignTo(userID) }} className="assign-task__select" />
                    </div>

                    <div className="group">
                        <DisplayError error={error} />
                    </div>

                    <LoadingButton loading={status == "pending"} className={"button--safe assign-task__assign-button"} onClick={assign}>Assign Editor</LoadingButton>
                </div>
            )}
        </React.Fragment>
    )
}

export default AssignTaskEditor;